import { render, staticRenderFns } from "./FengCai.vue?vue&type=template&id=733c32ac&"
import script from "./FengCai.vue?vue&type=script&lang=js&"
export * from "./FengCai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports